import React from "react";
import styled from "styled-components";

import { getPreview, getFileType } from "util/utility";
import Icon from "konnekt/Icon";
import useIsActiveConversationInsta from "customHooks/inbox/useIsActiveConversationInsta";

const Container = styled.div`
  position: relative;

  &:not(:last-child) {
    margin-right: ${(props) => (props.mediaPreview ? "18px" : "4px")};
  }
`;

const Item = styled.li`
  position: relative;
  background-color: #000000;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  min-width: 37px;
  height: 53px;
  width: 37px;

  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: hidden;

  &:hover > div {
    opacity: 0.8;
  }

  & > img,
  video,
  div {
    opacity: ${(props) => (props.active ? 1 : 0.3)};

    transition: opacity 0.2s ease-in-out;

    &:hover {
      opacity: 0.8;
    }
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Video = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
`;

const VideoIcon = styled(Icon)`
  position: absolute;
  left: 5px;
  bottom: 5px;
  z-index: 2;
`;

const PreviewIcon = styled(Icon)`
  opacity: ${(props) => (props.active ? 1 : 0.5)};

  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
`;

const IconContainer = styled.div`
  height: 19px;
  width: 19px;
  background-color: #000000;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid ${(props) => props.theme.colors.white};
`;

const Preview = ({
  data,
  active,
  setActiveItem,
  index,
  itemRef,
  mediaPreview,
  handleDeleteItem,
  listLength,
}) => {
  const contentType = data?.contentType;

  const isChatofInsta = useIsActiveConversationInsta();

  const renderPreviewType = () => {
    switch (getFileType(data.src) || contentType) {
      case "Image":
        return (
          <Image
            src={isChatofInsta ? data.src : getPreview(data.src)}
            alt={data.name}
          />
        );

      case "Video":
        return (
          <>
            <Video src={getPreview(data.src)} />
            <VideoIcon iconName="video" iconSize="tiny" color="white" />
          </>
        );

      case "Audio":
        return (
          <PreviewIcon active={active} iconName="audioPreview" iconSize="xs" />
        );
      default:
        return (
          <PreviewIcon active={active} iconName="docPreview" iconSize="xs" />
        );
    }
  };

  const renderCancelBtn = () => {
    if (mediaPreview && listLength > 1) {
      return (
        <IconContainer onClick={() => handleDeleteItem(index)}>
          <Icon iconName="close" width="9" height="9" color="white" />
        </IconContainer>
      );
    }
    return null;
  };

  return (
    <Container mediaPreview={mediaPreview}>
      <Item ref={itemRef} onClick={() => setActiveItem(index)} active={active}>
        {renderPreviewType()}
      </Item>
      {renderCancelBtn()}
    </Container>
  );
};

export default Preview;
